import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseHoldVisitChartsDataContext } from './hooks/useHouseHoldVisitChartsDataContext';

export const AnnualEvolutionHouseHoldVisit = () => {
    const { chartData } = useHouseHoldVisitChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Anual do Total de Visitas Domiciliares'}
            horizontal={false}
            subtitles={chartData?.annualEvolutionHouseHoldVisit?.map((item) => item.description)}
            values={chartData?.annualEvolutionHouseHoldVisit?.map((item) => item.total  ||  0)}
        />
    );
};
